const DEV = "production" !== process.env.NODE_ENV;
const OBJECT = "object";

export function logger(object, ...attrs) {
  if (!DEV || !attrs) return;
  let className;
  try {
    className =
      DEV === true && typeof object === OBJECT
        ? object.constructor.name
        : object.toString();
  } catch (e) {
    className = "";
  }
  // eslint-disable-next-line
  // console.log('logDev', arguments)
  // ("use strict");
  let methodName = "";
  try {
    methodName = arguments.callee.caller.name;
  } catch (error) {
    // console.log(error)
  }

  const name =
    0 < className.indexOf(".")
      ? className
      : className !== "" && methodName !== ""
      ? `${className}.${methodName}`
      : className !== ""
      ? className
      : methodName !== ""
      ? methodName
      : "unknown";

  console.log(`\x1b[1;94m[${name}]\x1b[0m`);
  console.log(...attrs);
}

export function whoAmI(_this_, _arguments_, deco = "1;94", optional) {
  if (DEV === true)
    return `\x1b[${deco}m[${
      _this_
        ? typeof _this_ === OBJECT
          ? _this_.constructor.name
          : _this_.toString()
        : "unknown"
    }.${
      _arguments_
        ? typeof _arguments_ === OBJECT
          ? _arguments_.callee.name
          : _arguments_.toString()
        : optional || ""
    }]\x1b[0m`;
  return `[${_this_ ? _this_.toString() : "unknown"}.${
    _arguments_
      ? typeof _arguments_ === OBJECT
        ? _arguments_.callee.name
        : _arguments_.toString()
      : optional || ""
  }]`;
}

export default {
  logger,
  whoAmI,
};
